import { createAction } from '@reduxjs/toolkit';

import {
    STORE_PINWHEEL_RESET,
    PINWHEEL_UPDATE_SALARY_INFO,
    PINWHEEL_CREATE_PRIMARY_JOB,
    PINWHEEL_SET_AMOUNT_TO_CHARGE,
} from '@perpay-web/fintech/constants/actionTypes';

export function setAmountToCharge(amount) {
    return {
        type: PINWHEEL_SET_AMOUNT_TO_CHARGE,
        payload: { amount },
    };
}

export function resetPinwheel() {
    return {
        type: STORE_PINWHEEL_RESET,
    };
}

export function pinwheelUpdateSalaryInfo(payload) {
    return {
        type: PINWHEEL_UPDATE_SALARY_INFO,
        payload,
    };
}

export function pinwheelCreatePrimaryJob(payload) {
    return {
        type: PINWHEEL_CREATE_PRIMARY_JOB,
        payload,
    };
}

export const pinwheelStepsSetStep = createAction('PINWHEEL_STEPS::SET_STEP');

export const pinwheelStepsGoBack = createAction('PINWHEEL_STEPS::GO_BACK');
